<div class="flex flex-col flex-auto min-w-0 bg-gray-50 dark:bg-gray-900 h-full">
    <!-- Header -->
    <div class="bg-white dark:bg-gray-800 border-b shadow-sm">
        <div class="flex flex-col w-full max-w-screen-xl mx-auto px-6 sm:px-8">
            <div class="flex flex-col sm:flex-row flex-auto sm:items-center min-h-24 py-6 sm:py-0">
                <div class="flex flex-col truncate">
                    <div class="text-3xl font-bold tracking-tight leading-none text-gray-900 dark:text-white">Gestión de procesos</div>
                    <div class="text-gray-500 text-base mt-2">Administra procesos y documentación de manera eficiente</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="flex-auto w-full max-w-screen-xl mx-auto p-6 sm:p-8">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            
            <!-- Card: Ejecutar Proceso (el backend exige crear_proceso_contratacion) -->
            <div *ngIf="permissions?.crearProcesoContratacion"
                 class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/contrataciones/ejecutar-procesos">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-blue-50 text-blue-600 group-hover:bg-blue-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="mat_outline:assignment_turned_in"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-blue-600 transition-colors">Ejecutar Proceso</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Inicia nuevos procesos</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-blue-600 group-hover:translate-x-1 transition-transform">
                        Iniciar
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div>

            <!-- Card: Control de Procesos (el backend exige control_procesos_contratacion) -->
            <div *ngIf="permissions?.controlProcesosContratacion"
                 class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/contrataciones/control-procesos">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-purple-50 text-purple-600 group-hover:bg-purple-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="mat_outline:assignment_turned_in"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-purple-600 transition-colors">Control de Procesos</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Supervisa el estado de los procesos, revisa avances y administra flujos de trabajo</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-purple-600 group-hover:translate-x-1 transition-transform">
                        Gestionar
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div>

            <!-- Card: Indicadores de contratación (mockup con datos de ejemplo; solo superusuario, igual que el guard de la ruta) -->
            <div *ngIf="isAdmin"
                 class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/contrataciones/indicadores">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-indigo-50 text-indigo-600 group-hover:bg-indigo-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="heroicons_outline:chart-bar"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-indigo-600 transition-colors">Indicadores de contratación</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Contratados, oportunidad de la firma, rechazos, afiliaciones y percepción del colaborador</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-indigo-600 group-hover:translate-x-1 transition-transform">
                        Ver indicadores
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div>

            <!-- Card: Evidencias de correo (acceso_evidencias_correo o superuser; el guard y el backend validan) -->
            <div *ngIf="isAdmin || permissions?.accesoEvidenciasCorreo"
                 class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/contrataciones/evidencias-correo">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-teal-50 text-teal-600 group-hover:bg-teal-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="heroicons_outline:mail"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-teal-600 transition-colors">Evidencias de correo</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Trazabilidad de los correos de firma: envío, entrega y copia</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-teal-600 group-hover:translate-x-1 transition-transform">
                        Consultar
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div>

            <!-- Card: Evaluaciones de Desempeño -->
            <!-- OCULTA TEMPORALMENTE: por ahora solo accesible por URL (/evaluaciones).
                 Descomentar esta card cuando el módulo esté listo para publicarse en el hub. -->
            <!--
            <div class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/evaluaciones">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-indigo-50 text-indigo-600 group-hover:bg-indigo-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="heroicons_outline:clipboard-document-check"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-indigo-600 transition-colors">Evaluaciones de Desempeño</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Configura plantillas por secciones, programa ciclos y consulta resultados del personal</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-indigo-600 group-hover:translate-x-1 transition-transform">
                        Configurar
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div>
            -->
            <!-- Fin card Evaluaciones (oculta) -->

            <!-- Card: Control de Documentos -->
            <div class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden opacity-75">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-gray-100 text-gray-400">
                            <mat-icon class="icon-size-8" svgIcon="heroicons_outline:document-text"></mat-icon>
                        </div>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2">Control de Documentos</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Repositorio centralizado de documentación. Consulta, carga y valida documentos por persona</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-gray-400 cursor-default">
                        Próximamente
                    </span>
                </div>
            </div>

            <!-- Card: Configuración Admin — oculto, solo accesible por URL /contrataciones/configuracion -->
            <!-- <div *ngIf="isAdmin"
                 class="flex flex-col bg-white dark:bg-card shadow-md rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group transform hover:-translate-y-1"
                 routerLink="/contrataciones/configuracion">
                <div class="p-8">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center justify-center w-14 h-14 rounded-full bg-emerald-50 text-emerald-600 group-hover:bg-emerald-100 transition-colors">
                            <mat-icon class="icon-size-8" svgIcon="heroicons_outline:cog"></mat-icon>
                        </div>
                        <span class="px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700">Admin</span>
                    </div>
                    <div class="text-xl font-bold text-gray-900 leading-tight mb-2 group-hover:text-emerald-600 transition-colors">Configuracion</div>
                    <div class="text-gray-500 text-sm leading-relaxed">Administra procedimientos, actividades, formularios, series documentales y plantillas</div>
                </div>
                <div class="flex items-center justify-end p-6 pt-0 mt-auto">
                    <span class="flex items-center font-medium text-emerald-600 group-hover:translate-x-1 transition-transform">
                        Configurar
                        <mat-icon class="icon-size-5 ml-2" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                    </span>
                </div>
            </div> -->

        </div>
    </div>
</div>
